<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="560"
    persistent
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subtitle-1 font-weight-bold">
          {{ $t("generic.lang_promoCodeScanHint") }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-2">
        <qrcode-stream
          v-if="dialog"
          class="rounded-lg"
          :torch="torch"
          @detect="onDetect"
          @init="onInit"
        />
        <div v-if="error" class="error--text text-center mt-3">
          {{ error }}
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PromoCodeScanDialog",

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      torch: false,
      error: null
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  watch: {
    value(open) {
      if (open) this.error = null;
    }
  },

  methods: {
    close() {
      this.dialog = false;
    },

    async onDetect(promise) {
      try {
        const { content } = await promise;
        if (content) this.$emit("scanned", String(content).trim());
      } catch (e) {
        this.error = this.$t("generic.lang_promoScanFailed");
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        this.error =
          e && e.name === "NotAllowedError"
            ? this.$t("generic.lang_promoCameraDenied")
            : this.$t("generic.lang_promoCameraUnavailable");
      }
    }
  }
};
</script>
